<template>
  <div>
    <Simulation
      :simulationDevices="simulationDevices"
      :busConfigurations="busConfigurations"
      simulationLabel="Mx2Dds5Em"
    >
    </Simulation>
  </div>
</template>

<script>
import Simulation from '@/components/Simulation';
import ResolDeltaSol_CSPlus_3d01 from '@/device-products/ResolDeltaSol_CSPlus_3d01.vue';

export default {
  components: {
    Simulation,
  },

  data: () => ({
    busConfigurations: [
      {
        label: 'GP', connections: [
        ],
      },
    ],
    simulationDevices: [
      { id: 0, component: ResolDeltaSol_CSPlus_3d01, deviceLabel: null },
      // { id: 1, component: DdsSensor, deviceLabel: 'DDS 1', deviceColor: 'green', props: {
      //   defaultSensorType: 'RPD',
      //   defaultValues: [ // FIXME(robin) defautl values anhand der conversion geht nicht, sieghe RCS (3 x raw)
      //     { conversion: 'rawTemperature', value: 22.0 },
      //     { conversion: 'rawPressure', value: 2.0 },
      //   ],
      // }},
      // { id: 2, component: DdsSensor, deviceLabel: 'DDS 2', deviceColor: 'green darken-2', props: {
      //   defaultSensorType: 'VFD2_40F',
      //   defaultValues: [
      //     { conversion: 'rawTemperature', value: 22.0 },
      //     { conversion: 'rawFlow', value: 4.0 },
      //   ],
      // }},
    ],
  }),
};
</script>

<style>

</style>
